module.exports = __webpack_public_path__ + "img/coolfox logo-wit.ae16cb56.png";